"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataSetModuleUi = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const ui_1 = require("../_abstract/ui");
/**
 * @author Kuba Fogel <kuba.fogel@movecloser.pl>
 */
let DataSetModuleUi = class DataSetModuleUi extends ui_1.AbstractModuleUi {
};
DataSetModuleUi = __decorate([
    vue_property_decorator_1.Component({
        name: 'DataSetModuleUi',
        template: `
    <div class="data-set-module">
      <p v-if="module.content.dataSet['name']" class="data-set-module__title">
        <strong>{{module.content.dataSet.name}}</strong>
      </p>

      <div class="data-set-module__table-wrapper">
        <table v-if="module.content.dataSet['data']" class="data-set-module__table">
          <tr v-for="(row, rowIndex) in module.content.dataSet.data" :key="rowIndex">
            <td v-for="(col, colIndex) in row" :key="colIndex"
                class="data-set-module__table__cell" :title="col">
              {{col}}
            </td>
          </tr>
        </table>
      </div>

      <span v-if="module.content.dataSet['note']" class="data-set-module__note">
        {{module.content.dataSet.note}}
      </span>
    </div>
  `
    })
], DataSetModuleUi);
exports.DataSetModuleUi = DataSetModuleUi;
//# sourceMappingURL=DataSet.ui.js.map